module.exports = __webpack_public_path__ + "static/media/snapshot_onboarding_ios_02_a.9ccdcf54.png";